<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Gadai</h5>
            </template>
            <DetailGadaiKomp :detailGadai="dataDetailGadai" />
            <div class="detail-edit-btn" >
                <b-button class="mr-2" variant="pgiBtn" name="gadaiEditBtn" v-if="dataDetailGadai.statusGadai == 'Berjalan' && allowedEdit == 1" @click="editGadai">Edit</b-button>
                <b-button class="mr-2" variant="cancelBtn" name="ajukanHilang" v-if="allowedHilang == 1" @click="openAjukanHilang">Ajukan Penghapusan Barang</b-button>
                <b-button variant="cancelBtn" name="setTarik" v-if="setTarik == 1" @click="openSetTarik">Set Tarik</b-button>
            </div>
        </b-card>

        <b-modal id="modal-ajukan-hilang" title="Ajukan Penghapusan Barang" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="ajukanNotaHilang" @submit.prevent="onSubmitAjukan">
                <DataFotoGadai :dataFotoPendukung="input.dataFotoPendukung" />
                <div class="form-content-wrapper mt-4 mb-0">
                    <b-form-group label="Keterangan" class="mb-0">
                        <b-form-textarea
                        v-model="input.keteranganNotaHilang"
                        name="keteranganNotaHilang"
                        rows="3"
                        required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelAjukanNotaBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeAjukanNotaBtn" :disabled="isSubmitting" type="submit" form="ajukanNotaHilang">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Ajukan Penghapusan Barang'}}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-set-tarik" title="Set Tarik Gadai" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="setTarikForm" @submit.prevent="onSetTarik">
                <DataFotoGadai :dataFotoPendukung="input.dataFotoPendukung" />
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelSetTarikBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeSetTarikBtn" :disabled="isSubmitting" type="submit" form="setTarikForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Set Tarik Gadai'}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

import DetailGadaiKomp from '../../components/gadai/DetailGadaiKomp';
import DataFotoGadai from '../../components/baranghilang/DataFotoGadai';

export default {
    name: 'detail-gadai',
    components: {
        DetailGadaiKomp,
        DataFotoGadai
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            dataDetailGadai: [],
            statusGadai: null,
            allowedEdit: 0,
            allowedHilang: 0,
            setTarik: 0,
            input:{
                keteranganNotaHilang: "",
                dataFotoPendukung: {
                    fotoPendukung: null,
                    fotoPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                } 
            }
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleGadai = this.$axios.get(`gadai/detail/id/${this.id}`).then(response => {
                this.dataDetailGadai = response.data
                console.log(response.data)
            })

            let getStatusGadai = this.$axios.get(`gadai/daftar-gadai/${this.id}/status`).then(response => {
                this.statusGadai = response.data.id
            })

            let getAllowedEdit = this.$axios.get("gadai/edit-allowed").then(response => {
                this.allowedEdit = response.data.id
                console.log(response.data)
            })

            let getAllowedHilang = this.$axios.get("gadai/barang-hilang-allowed").then(response => {
                this.allowedHilang = response.data.id
            })

            let getSetTarik = this.$axios.get(`daftar-penarikan/tarik-allowed?gadaiId=${this.id}`).then(response => {
                this.setTarik = response.data.id
                console.log(response.data)
            })

            Promise.all([getSingleGadai, getStatusGadai,getAllowedEdit, getAllowedHilang, getSetTarik]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        editGadai(){
            
            if(this.dataDetailGadai.barang.kendaraan != null){
                if(this.statusGadai !=0){
                    this.$router.push({path: `${this.$route.path}/kend-staging`});
                }else{
                    this.$router.push({path: `${this.$route.path}/kendaraan`});
                }
            }else{
                if(this.statusGadai !=0){
                    this.$router.push({path: `${this.$route.path}/elek-staging`});
                }else{
                    this.$router.push({path: `${this.$route.path}/elektronik`});
                }
            }
        },

        openAjukanHilang(){
            this.$bvModal.show("modal-ajukan-hilang")
        },

        onSubmitAjukan(){
            if (this.input.dataFotoPendukung.fotoPendukung == null && this.input.dataFotoPendukung.fotoPendukungBase64 == null) {
                this.$helper.toastErr(this, "Tolong upload foto terlebih dahulu!")
            } 
            else {
                let payload = new FormData()

                //----------------- Append Data Promo -----------------

                payload.append("gadaiId", this.id)
                payload.append("keterangan", this.input.keteranganNotaHilang)
                payload.append('foto', this.input.dataFotoPendukung.activeFotoPendukungBase64)
                
                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true

                this.$axios.post("gadai-hilang/pengajuan", payload).then(response => {
                    this.$helper.setFlash("Pengajuan nota hilang berhasil dilakukan")
                    let path = this.$route.path.split("/")
                    path.pop()
                    path = path.join("/")
                    this.$router.push({ path })
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        },

        openSetTarik(){
            this.$bvModal.show("modal-set-tarik")
        },

        onSetTarik(){
            if (this.input.dataFotoPendukung.fotoPendukung == null && this.input.dataFotoPendukung.fotoPendukungBase64 == null) {
                this.$helper.toastErr(this, "Tolong upload foto terlebih dahulu!")
            } 
            else {
                let payload = new FormData()

                //----------------- Append Data Promo -----------------

                payload.append("gadaiId", this.id)
                payload.append('foto', this.input.dataFotoPendukung.activeFotoPendukungBase64)
                
                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true

                this.$axios.post("daftar-penarikan/set-tarik", payload).then(response => {
                    this.$helper.setFlash("Gadai berhasil ditarik!")
                    let path = this.$route.path.split("/")
                    path.pop()
                    path = path.join("/")
                    this.$router.push({ path })
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        }
    },

    created(){
        this.init()
    }
}
</script>
